// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"10546a53","110":"300b1f45","264":"fa0ccefe","453":"5b090d2f","799":"073ab44b","931":"191009ed","989":"b3aa9f40"}[chunkId] + ".chunk.js";
};